import { z } from "zod";
import { BillStatus } from "@common/types/bill";

export const updateBillBodySchema = z
    .object({
        memo: z.string().max(1000).nullable().optional(),
        status: z.nativeEnum(BillStatus).optional(),
        paidAt: z.coerce.date().nullable().optional(),
    })
    .refine(
        (data) =>
            data.memo !== undefined ||
            data.status !== undefined ||
            data.paidAt !== undefined,
        {
            message: "At least one of memo, status, or paidAt must be provided",
        },
    )
    .refine(
        (data) =>
            data.status !== BillStatus.PAID ||
            (data.paidAt !== undefined && data.paidAt !== null),
        {
            message: "paidAt is required when setting status to paid",
        },
    )
    .refine(
        (data) => {
            if (data.paidAt === null) {
                return (
                    data.status !== undefined && data.status !== BillStatus.PAID
                );
            }
            return true;
        },
        {
            message:
                "Cannot clear paidAt without changing status away from paid",
        },
    )
    .refine(
        (data) => {
            if (data.paidAt !== undefined && data.paidAt !== null) {
                return data.status === BillStatus.PAID;
            }
            return true;
        },
        {
            message: "paidAt can only be set when status is paid",
        },
    );
